var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"section-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('N3Vue')],1)])]),_vm._v(" "),(_vm.$route.query.cateName)?_c('div',{staticClass:"select_category"},[_vm._v("\n    "+_vm._s(_vm.$route.query.cateName)+"\n  ")]):_vm._e(),_vm._v(" "),_c('cardList')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d52b6d9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/category.vue
// module id = null
// module chunks = 